var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"redeem-treasure-page pa-6",attrs:{"fluid":""}},[_c('redeem-treasure-view',{attrs:{"gameId":_vm.gameId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }